// @flow

import {customerSelector} from '../../Customer/selectors';
import {fetchCustomerSaga} from '../../Customer/sagas';
import {put, call, all, takeEvery, select} from 'redux-saga/effects';
import {setLoading} from '../../LoadingStatus/actions';
import {triggerProductOrderPolling} from '../../PollingOrder';
import {tripica} from '../../../api';
import {setDeliveryContact, setDeliveryContactFailure} from './actions';
import type {SignUpDeliveryContactActionType} from './actions';
import HandleErrorService from '../../../lib/handleError';
import omit from 'lodash/omit';
import {customerIndividualContactMediumsSelector} from '../../Individual/selectors';
import { loadTaxExemptionByArea } from '../../../lib/tripicaStaticConfig';
import WizzeeLog from '../../../lib/wizzeeLog';

export function* updateDeliveryContatMediumSaga(
  action: SignUpDeliveryContactActionType,
): Generator<*, *, *> {
  if (action.type !== 'SIGNUP_SET_DELIVERY_CONTACT') {
    return;
  }

  try {
    const {deliveryContact} = action.payload;

    yield put(setLoading('deliveryContact', true));
    yield put(setDeliveryContact(deliveryContact));

    // Get taxExemptionByArea from async storage
    const taxExemptionByArea = yield call(loadTaxExemptionByArea);
    if (taxExemptionByArea) {
      WizzeeLog.log('>>> taxExemptionByArea to apply on customer update', taxExemptionByArea);
    }

    let customer = yield select(customerSelector);
    if (customer) {
      if (customer.fullName) {
        customer = omit(customer, 'fullName');
      }
    }
    let mobileContactNumberMedium, deliveryContactMedium;

    const contactMediums = yield select(
      customerIndividualContactMediumsSelector,
    );
    if (contactMediums && contactMediums.length > 0) {
      deliveryContactMedium = contactMediums?.find(
        contactMedium =>
          contactMedium?.type === 'MOBILE_CONTACT_NUMBER' &&
          tripica.formatter.isAvailableForDate(contactMedium, Date.now()),
      );
    }
    if (deliveryContactMedium == undefined) {
      mobileContactNumberMedium = {
        medium: {
          type: 'NUMBER',
          number: deliveryContact.phoneNumber,
        },
        ouid: undefined,
        prefered: true,
        type: 'MOBILE_CONTACT_NUMBER',
      };
    } else {
      mobileContactNumberMedium = {
        ...deliveryContactMedium,
        medium: {
          ...deliveryContactMedium.medium,
          number: deliveryContact.phoneNumber,
        },
      };
    }
    const response = yield call(
      [tripica, 'updateContactMediums'],
      customer.ouid,
      'INDIVIDUAL',
      [mobileContactNumberMedium],
      taxExemptionByArea ?? undefined,
    );

    if (!response || !response.errorCodeList) {
      throw new Error('No response or error code list');
    }

    if (response && response.status === 'VALIDATED') {
      const productOrder = yield call(
        triggerProductOrderPolling,
        response.uuid,
      );
      if (productOrder) {
        yield call(fetchCustomerSaga);
      } else {
        throw new Error('product order fetch failed');
      }
    } else {
      throw new Error('status not validated');
    }
  } catch (e) {
    WizzeeLog.warn('[saga] updateDeliveryContatMedium', e);
    yield put(setDeliveryContactFailure(e));
    HandleErrorService.showToastError(e);
  } finally {
    yield put(setLoading('deliveryContact', false));
  }
}

export default function* (): Generator<*, *, *> {
  yield all([
    takeEvery('SIGNUP_SET_DELIVERY_CONTACT', updateDeliveryContatMediumSaga),
  ]);
}
